'use client';
import { Tooltip as ReactTooltip } from 'react-tooltip';

const Tooltip = () => {
  return (
    <ReactTooltip
      id='chenook-tooltip'
      disableStyleInjection
      render={({ content }: { content: string | null }) => (
        <div className='bg-amber-950 text-orange-200 text-sm px-2 py-1 rounded-lg'>
          {content}
          <div className='bg-amber-950 absolute w-1.5 h-1.5 transform rotate-45 -bottom-0.5 left-1/2 -translate-x-1/2'></div>
        </div>
      )}
    />
  );
};

export default Tooltip;
